module.exports = __webpack_public_path__ + "static/WelcomeToElk11-79f110b277d0a65ba14cb36bb7b23e9c.webp";